import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type AirActionTrackingLocation, useTrackRegeneratedShareLink } from '@air/analytics';
import { ShortUrl } from '@air/api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getShortIdInformationKey } from '~/swr-hooks/shortUrl/useGetExistingShortIdInformation';

export const useRegenerateShortIdForCanvas = () => {
  const queryClient = useQueryClient();
  const { trackRegeneratedShareLink } = useTrackRegeneratedShareLink();

  const regenerateShortIdForCanvas = useMutation({
    mutationFn: (params: {
      workspaceId: string;
      canvasId: string;
      shortId: string;
      trackLocation: AirActionTrackingLocation;
    }) =>
      ShortUrl.regenerateShortId({
        workspaceId: params.workspaceId,
        id: params.shortId,
      }),
    onSuccess: (shortIdInfo, { canvasId, trackLocation }) => {
      queryClient.setQueryData(getShortIdInformationKey({ objectId: canvasId, boardContext: undefined }), shortIdInfo);

      trackRegeneratedShareLink({ shortId: shortIdInfo.id, location: trackLocation });

      return shortIdInfo;
    },
    onError: (error, params) => {
      throw reportErrorToBugsnag({
        error,
        context: 'Failed to regenerate short id for canvas',
        metadata: { data: params },
      });
    },
  });

  return {
    regenerateShortIdForCanvas,
  };
};
